module.exports = __webpack_public_path__ + "img/Antonia&Stephan-04.47051b42.jpg";